module.exports = __webpack_public_path__ + "static/media/jungle_page8.320d60f9.png";